import React, { createContext, useState, useEffect } from 'react';
import { getAuthUser } from '../api/AuthAPI';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            getAuthUser((response) => {
                if (response.user) {
                    setUser(response.user);
                }
                setIsLoading(false);
            });
        } else {
            setIsLoading(false);
        }
    }, []);

    const login = (token) => {
        localStorage.setItem('token', token);
        setIsLoading(true);
        // Fetch user details and update the state. That's it.
        getAuthUser((response) => {
            if (response.user) {
                setUser(response.user);
            }
            setIsLoading(false);
        });
    };

    const logout = (navigate) => {
        localStorage.removeItem('token');
        setUser(null);
        if (navigate) {
            navigate('/login');
        }
    };

    return (
        <AuthContext.Provider value={{ user, login, logout, isLoading }}>
            {children}
        </AuthContext.Provider>
    );
};

